<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
/* @import "./common/font/font.css"; */
#app {
  min-width: 1200px;
  height: 100%;
  font-family: "SourceHanSans-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue